const colorStatus = new Array<string>(
  '#fff',
  '#198754',
  '#ffc107',
  '#dc3545',
  '#000'
);

export { colorStatus };
